/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AuthClientAudienceEntry,
  AuthClientAudienceEntry$inboundSchema,
} from "./authclientaudienceentry.js";

/**
 * Who may use an auth client.
 */
export type AuthClientAudience = {
  /**
   * The auth client id.
   */
  authClientId: string;
  /**
   * The rules deciding who may use the client.
   */
  entries: Array<AuthClientAudienceEntry>;
  /**
   * Ids of public servers that offer the client. Anonymous callers on them never acquire these rules.
   */
  publicServers: Array<string>;
  /**
   * Pass back as expected_version when saving, so an edit made against a stale list is refused.
   */
  version: string;
};

/** @internal */
export const AuthClientAudience$inboundSchema: z.ZodMiniType<
  AuthClientAudience,
  unknown
> = z.pipe(
  z.object({
    auth_client_id: z.string(),
    entries: z.array(AuthClientAudienceEntry$inboundSchema),
    public_servers: z.array(z.string()),
    version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "auth_client_id": "authClientId",
      "public_servers": "publicServers",
    });
  }),
);

export function authClientAudienceFromJSON(
  jsonString: string,
): SafeParseResult<AuthClientAudience, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AuthClientAudience$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AuthClientAudience' from JSON`,
  );
}
